class Attachment {
  id = '';
  name = '';
  inputFile;
}

export default Attachment;
